import { Link, useLocation, useNavigate } from "react-router-dom";
import media from "../../../media";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { sideMenu } from "../../../utils/Constants";
import { switchBackThunk } from "../../../store/thunks/authThunk";
import CustomLoader from "../../../utils/CustomLoader";
import { useState } from "react";

export default function Sidebar() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeMenu = location?.pathname;

  let storeRole = useSelector((state) => state.auth.role);
  const ercount = useSelector((state) => {
    return state.auth.ercount;
  });

  const { isDelegated, name, empID } = useSelector((state) => state.auth);
  const actingUser = useSelector((state) => state.auth.actingUser);
  const originalUser = useSelector((state) => state.auth.originalUser);
  const [showLoader, setShowLoader] = useState(false);  
  const handleSwitchBack = async () => {
    setShowLoader(true);
    try {      
      await dispatch(switchBackThunk({lIUId: originalUser?.lIUId, loginAsUserId: actingUser?.lIUId})).unwrap();
      message.success("Switched back to your account");      
      navigate("/dashboard", { replace: true });
      setShowLoader(false);
    } catch (err) {
      setShowLoader(false);
      message.error(err || "Failed to switch back");      
    }
  };

  return (
    <>
    <CustomLoader showLoader={showLoader} />
    <div
      className="aside aside-left aside-fixed d-flex flex-column flex-row-auto custom-aside-menu-style"
      id="kt_aside"
    >
      <div className="brand flex-column-auto" id="kt_brand">
        <Link to="/dashboard" className="brand-logo">
          <img alt="Logo" src={media.newLogo.svg} className="logo-style" />
        </Link>
      </div>
      {/*Except approver who can not send expense request can use this event*/}
      <div
        className="aside-menu-wrapper flex-column-fluid scrollbars"
        id="kt_aside_menu_wrapper"
      >
        <div
          id="kt_aside_menu"
          className="aside-menu"
          data-menu-vertical="1"
          data-menu-scroll="1"
          data-menu-dropdown-timeout="500"
        >
          <ul className="menu-nav">
            {sideMenu &&
              typeof sideMenu === "object" &&
              sideMenu?.[storeRole]?.map((menuItem, index) => {
                const [key, value] = Object.entries(menuItem)[0]; // Extract key and value
                return (
                  <li
                    key={key}
                    className={
                      activeMenu === key
                        ? "menu-item menu-item-active"
                        : "menu-item"
                    }
                    onClick={() => {
                      message.destroy("publishDraftExpenseError");
                    }}
                  >
                    <Link className="menu-link" to={key}>
                      <span className="svg-icon menu-icon">
                        <img src={value.icon} alt={value.name} />
                      </span>
                      <span className="menu-text">
                        {value.name}
                        {value.showCount === "yes" && (
                          <span className="label label-dark label-lg ml-2 text-white font-weight-bold">
                            {ercount ? ercount : 0}
                          </span>
                        )}
                      </span>
                    </Link>
                  </li>
                );
              })}
            {/* {isDelegated && (
              <div
                style={{
                  padding: "10px",
                  margin: "10px",
                  borderRadius: 8,
                  background: "#fff3cd",
                  fontSize: 13,
                }}
              >
                <strong>Impersonating:</strong> {name} (Emp. ID. - {empID})
                <br />
                <button
                  style={{
                    marginTop: 6,
                    padding: "4px 8px",
                    borderRadius: 6,
                    border: "1px solid #856404",
                    background: "#fff",
                    cursor: "pointer",
                  }}
                  onClick={handleSwitchBack}
                >
                  Switch Back
                </button>
              </div>
            )} */}
          </ul>
        </div>
      </div>
    </div>
    </>
  );
}
